/**
 * The URL pathname schema
 */
type PathnameSchema = {
    fields: string[];
    schema: string;
};

type ENV = {
    location: Location;
    navigator: Navigator;
    document: Document;
    performance: Performance;
};

/**
 * Log level
 */
export enum Level {
    Log,
    Warn,
    Error,
}

export type Device = {
    sw: number;
    sh: number;
    dpr: number;
    phone: string;
    os: string;
    browser: string;
    language?: string;
    platform?: string;
    uad?: string;
    ua?: string;
};

export type Payload = {
    lv: Level;
    lid: number;
    pid: number;
    rid?: number;
    u?: string;
    h?: string;
    d: number;
    o: string;
    p?: string;
};

/**
 * Options
 */
export type HyperthymesiaOptions = {
    /**
     * Product ID
     */
    pid: string | number;
    service: string;
    target: string;
    huid?: string | number;
    target4Warning?: string;
    target4Failed?: string;
    cookieKeys?: string[];
    queryKeys?: string[];
    pathnameKeys?: PathnameSchema;
    defaultArgs?: { [key: string]: string | number | boolean };
    deviceInfo?: Device;
    sendfunc?: (url: string) => void;
    defaultEnv?: ENV;
    lazyInit?: Function;
    initId?: number;
};
